import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20warm%20red%20velvet%20curtains%20and%20golden%20stage%20lights%2C%20elegant%20and%20dramatic%20atmosphere%2C%20empty%20theater%20with%20soft%20ambient%20lighting%2C%20professional%20cinema%20photography%2C%20rich%20dark%20tones%20with%20crimson%20and%20gold%20accents%2C%20no%20people&width=1920&height=1080&seq=hero-cinema-bg&orientation=landscape"
        alt="木瓜影院 - 免费在线观影平台"
        title="木瓜影院 - 您的首选在线观影平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-black/30" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-500/30 mb-6">
            <i className="ri-movie-2-fill text-primary-300 text-sm"></i>
            <span className="text-xs font-medium text-primary-200">海量高清影视，永久免费畅看</span>
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            您的首选
            <span className="text-primary-400">在线观影</span>
            平台
          </h1>
          <p className="text-sm md:text-base text-foreground-300 max-w-xl mx-auto mb-8 leading-relaxed">
            木瓜影院汇聚海量高清电影、电视剧、综艺、动漫资源，无需注册即可免费畅看。
            多线路播放，更新速度快，画质清晰，随时随地享受极致观影体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/dianying"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-foreground-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-fill text-lg"></i>
              开始观影
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-background-50/20 backdrop-blur-sm border border-foreground-300/30 text-foreground-200 font-medium text-sm hover:bg-background-50/30 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-information-line text-lg"></i>
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-12">
            {[
              { value: '100,000+', label: '影视资源' },
              { value: '500,000+', label: '日均用户' },
              { value: '4K', label: '超清画质' },
              { value: '24h', label: '极速更新' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-bold text-white font-heading">
                  {stat.value}
                </div>
                <div className="text-xs text-foreground-400 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}